export default __webpack_public_path__ + "static/media/gasTubeTrailer.69aea6f5.svg";